import { SVGUniqueID } from './svg-unique-id';
import type { IconProps } from './types';
const Icon = (props: IconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    width={props.size || 24}
    height={props.size || 24}
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#clip0_3086:65112)">
      <path
        d="M25 10.4545L21.0328 10.0909L13.8197 17L8.04918 11.5455L3 9"
        stroke="#360272"
        strokeWidth={1.03125}
      />
      <path
        d="M3 18L7.82834 12.3831L14.4956 8L19.8906 14.3333L26 14.0877"
        stroke="#07C3D7"
        strokeWidth={1.03125}
      />
    </g>
    <defs>
      <clipPath id="clip0_3086:65112">
        <rect
          width={18}
          height={11}
          fill="white"
          transform="translate(3 7)"
        />
      </clipPath>
    </defs>
  </svg>
);
const SvgMultiLineChart = (props: IconProps) => (
  <SVGUniqueID>{Icon(props)}</SVGUniqueID>
);
export default SvgMultiLineChart;
